import { render, staticRenderFns } from "./AffiliateSignup.vue?vue&type=template&id=156f58bf"
import script from "./AffiliateSignup.vue?vue&type=script&lang=js"
export * from "./AffiliateSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports